<template>
  <span class="ol_badge js-tooltip cursor-pointer label label-warning" data-title="Off label"> OL </span>
</template>
<script>
export default {
  name: 'olLabel',
};
</script>
